import { useTranslation } from "react-i18next";
import { ACCOUNT_DETAILS_PAGE_URL } from "@constants";
import { SectionTitle } from "@common/SectionTitle/SectionTitle";
import { SubNavigation } from "@common/Navigation/SubNavigation";
import { OrderHandler } from "@features/Order/handler/OrderHandler";

export const OrderPage = () => {
    const { t } = useTranslation("order");

    return (
        <>
            <SubNavigation />
            <div className="container-boxed">
                <SectionTitle backButtonUrl={ACCOUNT_DETAILS_PAGE_URL} title={t("myOrders")} />
                <OrderHandler />
            </div>
        </>
    );
};
